(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ss-cannonball-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('toggle', (event) => {
  const group = event.target;
  if (!(group instanceof HTMLDetailsElement) || !group.matches('.cb-public-menu__group') || !group.open) return;
  group.closest('.cb-public-menu').querySelectorAll('details[open]').forEach((other) => {
    if (other !== group) other.open = false;
  });
}, true);
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const group = event.target.closest?.('.cb-public-menu__group[open]');
  if (group) { group.open = false; group.querySelector('summary').focus(); }
});
  } catch(e) { console.error(e); }
})();

})();
